import { AuthUser, LoginDto, RegisterDto, User } from '../../domain/entities';
import { API_CONFIG } from '../../core/config/constants';
import { apiClient } from './axios-config';

export const authApi = {
  login: async (credentials: LoginDto): Promise<AuthUser> => {
    const { data } = await apiClient.post<AuthUser>(API_CONFIG.ENDPOINTS.AUTH.LOGIN, credentials);
    return data;
  },

  register: async (userData: RegisterDto): Promise<AuthUser> => {
    const { data } = await apiClient.post<AuthUser>('/user/new', userData);
    return data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post(API_CONFIG.ENDPOINTS.AUTH.LOGOUT);
  },

  getCurrentUser: async (): Promise<User> => {
    const { data } = await apiClient.get<User>('/user/check');
    return data;
  }
};